import createLucideIcon from '../createLucideIcon';

const XCircle = createLucideIcon('XCircleIcon', [
  ['circle', { cx: '12', cy: '12', r: '10', key: '1mglay' }],
  ['line', { x1: '15', y1: '9', x2: '9', y2: '15', key: '19zs77' }],
  ['line', { x1: '9', y1: '9', x2: '15', y2: '15', key: '10u9bu' }],
]);

export default XCircle;
